import { gql } from "@apollo/client";

export const LIST_OFFERINGS = gql`
  query listOfferings($target: ProfileTypeEnum) {
    listOfferings(target: $target) {
      id
      title
      description
      target
      offeringType
      image
      price
      offerPrice
      currency
      offeringStatus
      expireAt
      createdAt
    }
  }
`;
